import { GIFT_CARDS } from '../paths'

const createUrlMap = () => ({
  Australia: GIFT_CARDS,
  'New Zealand': 'https://giftcards.westfield.co.nz/',
})

const getGiftcardUrl = country => {
  const GIFT_CARDS_URL_MAP = createUrlMap()
  return GIFT_CARDS_URL_MAP[country] || GIFT_CARDS_URL_MAP['Australia']
}

export default getGiftcardUrl
